module.exports = __WEBPACK_EXTERNAL_MODULE_30__;


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 30
// module chunks = 0